export default "/images/mf-logo.svg?e5c0c7d55710c50c04b1dde7254f714b";